<template>
    <div class="problemManual">
        <div class="layout-box-white-bg-ig6pe">
            <div class="manual-content">
                <section class="simple-2S7p1">
                    <span class="title">{{ProblemSolution.solutionName}}</span>
                </section>
                <div class="content-info">
                    <img :src="ProblemSolution.fileUrl" alt="">
                </div>
                <div class="recommond-course" v-if="show">
                    <h2 class="title">班会课</h2>
                    <div class="course-panel">
                        <div class="course-item " v-for="(item,index) in ProblemSolution.classMeetings" :key="index">
                            <a class="course-link-22BqB" href="" rel="noreferrer" target="_blank">
                                <div class="course-pic-YTvjF">
                                    <img alt="course-item" :src="item.coverImgUrl"></div>
                                <div :title="item.classMeetingName" class="course-title-3Ikmu">{{item.classMeetingName}}</div>
                                <div class="course-desc-1wQGf" title="">
                                   {{item.description}}
                                </div>
                            </a>
                            <div class="grade-tag-list">
                                <p class="ant-tag ant-tag-has-color" style="background-color: rgb(85, 164, 250);">高一</p>
                                <p class="ant-tag ant-tag-has-color" style="background-color: rgb(118, 208, 74);">高二</p>
                                <p class="ant-tag ant-tag-has-color" style="background-color: rgb(252, 192, 57);">高三</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recommond-course" v-if="show1">
                    <h2 class="title">推荐课程</h2>
                    <div class="course-panel">
                        <div class="course-item "  v-for="(item,index) in ProblemSolution.videCourse" :key="index">
                            <a class="course-link-22BqB" href="" rel="noreferrer" target="_blank">
                                <div class="course-pic-YTvjF">
                                    <img alt="course-item"  :src="item.coverImg"></div>
                                <div :title="item.classMeetingName" class="course-title-3Ikmu">{{item.classMeetingName}}</div>
                                <div class="course-desc-1wQGf" title="">
                                    <p>
                                        {{item.description}}
                                    </p>
                                </div>
                            </a>
                            <div class="view-score">
                                <span>观看 {{item.playTimes}}</span>
                                <span>评分 {{item.score}}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
        <div class="manual-aside-nav">
            <el-tree
                    :data="ProblemCategory"
                    :props="defaultProps"
                    default-expand-all
                    ref="tree"
                    :highlight-current=true
                    :check-on-click-node="true"
            >
                <!--嵌套其中的值，scope的data可以获得当前节点的值，这样写实现嵌套效果-->
                <div slot-scope="{node,data}" style="width: 180px;">

                    <div @click="node.level>1?selectUnit(data.categoryId):''"
                           :class="unitId===data.categoryId?'directoryActive':''"
                           style="padding:10px 5px;!important;"
                           :style="node.level===1?'font-weight:bolder;font-size:1.1em;':''"
                           class=" text-ellipsis"
                           :title="data.categoryName"  >
                        <span  >
                            {{data.categoryName}}
                        </span>

                    </div>

                </div>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import {stuProblemCategory, stuProblemSolution} from "../../../config";
    export default {
        name: "problemManual",
        data(){
            return{
                ProblemCategory:[],
                defaultProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                ProblemSolution:[],
                unitId:'',
                show:true,
                show1:true,

            }
        },

        methods:{
              async getStuProblemCategory(){
                  let res = await stuProblemCategory();
                  if (res.status){
                      this.ProblemCategory = res.data;
                      this.unitId=res.data[0].children[0].categoryId;
                      console.log(this.unitId);
                      this.getSolution(this.unitId);
                  }
              },
            async getSolution(val){
                let res = await stuProblemSolution(val);
                if (res.status){
                    this.ProblemSolution = res.data;
                    if (res.data.classMeetings.length===0){
                        this.show = false
                    }
                    if (res.data.videCourse.length===0){
                        this.show1 = false
                    }
                }
            },
           async selectUnit(val){
                 this.getSolution(val);
            }
        },
        created() {
            this.getStuProblemCategory();
        }
    }
</script>

<style scoped lang="scss">
    .problemManual {
        .layout-box-white-bg-ig6pe {
            background-color: #fff;
            padding: 0 32px 32px 32px;
            margin-right: 200px;
            .manual-content {
                margin-right: 8px;
                width: 100%;
                .simple-2S7p1 {
                    border-bottom: 1px solid #E6EAF5;
                    font-size: 18px;
                    padding: 22px 0;
                    color: #373a44;
                    position: relative;
                    margin-bottom: 16px;
                }

                .content-info {
                    text-align: center;

                    img {
                        max-width: 100%;
                    }
                }

                .recommond-course {
                    margin-top: 32px;
                    margin-bottom: 20px;
                    border-top: 1px solid #e6eaf5;

                    .title {
                        margin: 32px 0 25px;
                        font-size: 18px;
                        color: #373a44;
                        line-height: 26px;
                    }

                    .course-panel {

                        flex-wrap: wrap;

                        .course-item {
                            margin-bottom: 16px;
                            width: 224px;
                            border: 1px solid #E5EAF4;
                            padding-bottom: 16px;
                            position: relative;
                            margin-right: 16px;
                            transition: all .2s;
                            display: inline-block;

                            .course-link-22BqB {
                                display: block;

                                .course-pic-YTvjF {
                                    width: 100%;
                                    height: 122px;
                                    overflow: hidden;

                                    img {
                                        max-width: 100%;
                                    }
                                }

                                .course-title-3Ikmu {
                                    height: 22px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    text-align: left;
                                    color: #314059;
                                    line-height: 22px;
                                    padding: 0 16px;
                                    margin: 8px 0;
                                    width: 100%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                .course-desc-1wQGf {
                                    font-size: 12px;
                                    font-weight: 400;
                                    text-align: left;
                                    color: #8d96ac;
                                    line-height: 20px;
                                    padding: 0 16px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    height: 60px;
                                }
                            }

                            .grade-tag-list {

                                position: absolute;
                                right: 4px;
                                top: 4px;
                                flex-flow: column;
                            }
                            .view-score {
                                display: flex;
                                justify-content: space-between;
                                padding: 0 16px;
                                color: #314059;
                                font-size: 12px;
                                margin-top: 7px;
                            }
                        }
                    }
                }
            }


        }
        .manual-aside-nav {
            width: 200px;
            padding: 16px;
            background-color: #fff;
            position: absolute;
            top: 80px;
            right: 0;
        }
    }
</style>
